import {
  AssessmentOutlined,
  DomainOutlined,
  GroupOutlined,
} from '@mui/icons-material';
import { SxProps, Theme } from '@mui/material';
import {
  SCORECARD_COMMON_GOAL_TYPE_CUSAT,
  SCORECARD_GOAL_TYPE_CUSAT,
  SCORECARD_GOAL_TYPE_METRIC,
} from 'constants/scorecards';

interface GoalTypeIconProps {
  type?: string | null;
  sx?: SxProps<Theme>;
}

export default function GoalTypeIcon({ type, sx }: GoalTypeIconProps) {
  if (type === SCORECARD_GOAL_TYPE_METRIC) {
    return (
      <AssessmentOutlined
        aria-hidden="true"
        className="goal-type-icon"
        sx={sx}
      />
    );
  }

  if (
    type === SCORECARD_GOAL_TYPE_CUSAT ||
    type === SCORECARD_COMMON_GOAL_TYPE_CUSAT
  ) {
    return (
      <DomainOutlined aria-hidden="true" className="goal-type-icon" sx={sx} />
    );
  }

  return (
    <GroupOutlined aria-hidden="true" className="goal-type-icon" sx={sx} />
  );
}
